import Rdp from "./Rdp/dataSource/api/apiDataSourceRdp";
import Main from "./Main/dataSource/api/apiDataSourceMain";
import File from "./File/dataSource/api/apiDataSourceFile";

export default class ApiService {
	Rdp: Rdp;
	Main: Main;
	File: File;	
	constructor(cookieName?: string) {
		this.Rdp = new Rdp(cookieName);
		this.Main = new Main(cookieName);
		this.File = new File(cookieName);
	}
}